
import { useNavigate } from 'react-router-dom';
import { FcMediumPriority, FcSerialTasks, FcOk, FcHighPriority } from "react-icons/fc"
import { FiSmartphone, FiDollarSign, FiCreditCard } from "react-icons/fi"


const separate = (Number) => {
     Number += '';
     Number = Number.replace(',', '');
     let x = Number.split('.');
     let y = x[0];
     let z = x.length > 1 ? '.' + x[1] : '';
     var rgx = /(\d+)(\d{3})/;
     while (rgx.test(y))
          y = y.replace(rgx, '$1' + ',' + '$2');
     return y + z;
}

const RequestCheckoutList = ({ data }) => {

     const navigate = useNavigate()

     return (
          <>
               {data.length !== 0 && data ? (
                    data.map((item, i) => (
                         <div key={i} className="itemBox">
                              <div className="dtr">
                                   <div className="flex">

                                        <div className="posterItem" style={{ fontSize: '80px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                             {item?.withdrawalType?.id === 0 && <FcMediumPriority />}
                                             {item?.withdrawalType?.id === 1 && <FcSerialTasks />}
                                             {item?.withdrawalType?.id === 2 && <FcOk />}
                                             {item?.withdrawalType?.id === 3 && <FcHighPriority />}
                                             <small style={{ fontSize: '12px', marginTop: '6px' }}>{item?.withdrawalType.title}</small>
                                        </div>


                                        <div className="contentItem">

                                             <p className="title">
                                                  <span className="ltr ellipsis" style={{ float: 'right', marginLeft: '10px' }}>{item?.user.firstName}</span>
                                                  {item?.user.lastName && (<><small className="ellipsis">({item?.user.lastName})</small></>)}
                                             </p>

                                             <p className="">
                                                  <FiSmartphone />
                                                  {item?.user.userName}
                                             </p>
                                             <p className="">
                                                  <FiDollarSign />
                                                  مبلغ : {separate(item?.price)} تومان
                                             </p>

                                             <p className="cats">
                                                  <FiCreditCard />
                                                  شبا : <span className='ltr' style={{ letterSpacing: '1px', marginRight: '5px' }}>{`IR ${item?.user.shebaNumber}`}</span>
                                                  {/* <span>{user.role.name}</span> */}
                                             </p>


                                        </div>
                                   </div>
                              </div>
                              <div className="dtl">
                                   <button onClick={() => navigate('/checkout/request/' + item?.withdrawalId)}>ثبت پرداختی</button>
                                   <button onClick={() => navigate('/users/' + item?.user?.userId)}>ویرایش کاربر</button>
                                   {item.withdrawalType.id !== 3 && (
                                        <button onClick={() => navigate('/checkout/request/reject/' + item?.withdrawalId)} className='bordered'>رد درخواست</button>
                                   )}
                              </div>
                         </div>
                    ))

               ) : ''}
          </>
     )
}


export default RequestCheckoutList